import { TableHead, TableRow, TableCell, Box, IconButton } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { ArrowUpward, ArrowDownward, Sort } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

function UsersTableHeader({ sortConfig, onSort }) {
  const { t } = useTranslation();
  const theme = useTheme();

  const columns = [
    { key: "first_name", label: t("myUserManagement.firstNameLabel") },
    { key: "last_name", label: t("myUserManagement.lastNameLabel") },
    { key: "username", label: t("myUserManagement.usernameLabel") },
    { key: "created_at", label: t("myUserManagement.createdAtLabel") },
    { key: "updated_at", label: t("myUserManagement.updatedAtLabel") },
    { key: "status", label: t("myUserManagement.statusLabel") },
  ];

  const getSortIcon = (columnKey) => {
    if (sortConfig.key === columnKey) {
      return sortConfig.direction === "asc" ? (
        <ArrowUpward fontSize="small" />
      ) : (
        <ArrowDownward fontSize="small" />
      );
    }
    return <Sort fontSize="small" />;
  };

  const getSortAriaLabel = (columnKey, columnLabel) => {
    const direction =
      sortConfig.key === columnKey && sortConfig.direction === "asc"
        ? t("myUserManagement.ascendingAria")
        : t("myUserManagement.descendingAria");

    return t(
      `myUserManagement.sort${columnKey.charAt(0).toUpperCase() + columnKey.slice(1).replace(/_/g, "")}Aria`,
      {
        direction,
      }
    );
  };

  return (
    <TableHead>
      <TableRow
        sx={{
          "& .MuiTableCell-head": {
            backgroundColor:
              theme.palette.mode === "dark"
                ? alpha(theme.palette.background.paper, 0.8)
                : theme.palette.grey[50],
            fontWeight: 600,
            fontSize: "0.875rem",
            borderBottom: `2px solid ${theme.palette.divider}`,
            color: theme.palette.text.primary,
          },
        }}
      >
        <TableCell sx={{ width: 50 }} />
        {columns.map((column) => (
          <TableCell key={column.key}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {column.label}
              <IconButton
                size="small"
                onClick={() => onSort(column.key)}
                sx={{
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                aria-label={getSortAriaLabel(column.key, column.label)}
              >
                {getSortIcon(column.key)}
              </IconButton>
            </Box>
          </TableCell>
        ))}
        <TableCell>{t("myUserManagement.actionsLabel")}</TableCell>
      </TableRow>
    </TableHead>
  );
}

export default UsersTableHeader;
